'use client'

import { useEffect } from 'react'
import { ErrorPageShell } from '@/components/ErrorPageShell'

/**
 * Top-level error boundary. Catches errors thrown in the root layout
 * itself, so it must render its own <html>/<body> (the root layout
 * may not have run successfully). Visual matches /not-found and
 * /error: fuchs brand header, eyebrow + title + lead, ghost-CTA row.
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('[global error boundary]', error)
  }, [error])

  return (
    <html lang="de">
      <body style={{ margin: 0 }}>
        <ErrorPageShell
          eyebrow="Anwendungsfehler"
          title="Die Anwendung konnte nicht geladen werden."
          lead="Ein schwerwiegender Fehler beim Initialisieren ist aufgetreten. Bitte lade die Seite neu — oder kehre zur Startseite zurück."
          primaryAction={{ label: 'Nochmal versuchen', onClick: reset }}
          secondaryAction={{
            label: 'Startseite',
            onClick: () => { if (typeof window !== 'undefined') window.location.href = '/' },
          }}
          details={{
            summary: 'Fehlerdetails anzeigen',
            body: error?.message || 'Unbekannter Fehler',
            digest: error?.digest,
          }}
        />
      </body>
    </html>
  )
}
